<ng-container *ngIf="rideOpsUi.isV2Active$ | async; else v1CloseLocation">
	<div class="close-location">
		<header class="close-location-header">
			<h2 class="close-location-title">{{ "CLOSE_LOCATION__TITLE" | transloco }}</h2>
		</header>

		<section
			class="close-location-section"
			*ngIf="allowChangingDispatchesWhenClosingLocation$ | async"
		>
			<p class="close-location-label">{{ "CLOSE_LOCATION__CYCLES" | transloco }}</p>
			<app-number-counter
				[(value)]="dispatches"
				[disabled]="(assetDispatchActive$ | async) === true"
				[ariaLabel]="'CLOSE_LOCATION__CYCLES' | transloco"
			></app-number-counter>
			<p class="close-location-help">{{ "CLOSE_LOCATION__CYCLES_HELP_TEXT" | transloco }}</p>
		</section>

		<section class="close-location-section" *ngIf="allowChangingRidersWhenClosingLocation$ | async">
			<p class="close-location-label">{{ "CLOSE_LOCATION__RIDERS" | transloco }}</p>
			<app-number-counter
				[(value)]="riders"
				[disabled]="(assetDispatchActive$ | async) === true"
				[ariaLabel]="'CLOSE_LOCATION__RIDERS' | transloco"
			></app-number-counter>
			<p class="close-location-help">{{ "CLOSE_LOCATION__RIDERS_HELP_TEXT" | transloco }}</p>
		</section>

		<footer class="close-location-footer">
			<button
				type="button"
				class="close-location-submit"
				[disabled]="isClosing"
				(click)="close()"
			>
				{{ "CLOSE_LOCATION__CLOSE_RIDE" | transloco }}
			</button>
		</footer>
	</div>
</ng-container>

<ng-template #v1CloseLocation>
	<div class="close-location-content">
		<div class="headline">
			<div class="headline-text">
				{{ "CLOSE_LOCATION__TITLE" | transloco }}
			</div>
		</div>

		<app-grouping [label]="'CLOSE_LOCATION__CYCLES'" *ngIf="allowChangingDispatchesWhenClosingLocation$ | async">
		<app-number-selector [(selectedValue)]="dispatches"></app-number-selector>
			<div class="help-text">
				{{ "CLOSE_LOCATION__CYCLES_HELP_TEXT" | transloco }}
			</div>
		</app-grouping>

		<app-grouping [label]="'CLOSE_LOCATION__RIDERS'" *ngIf="allowChangingRidersWhenClosingLocation$ | async">
		<app-number-selector [(selectedValue)]="riders"></app-number-selector>
			<div class="help-text">
				{{ "CLOSE_LOCATION__RIDERS_HELP_TEXT" | transloco }}
			</div>
		</app-grouping>

		<div class="button-container">
			<div class="close-text">
				{{ "CLOSE_LOCATION__SET_STATUS_AS_CLOSED" | transloco }}
			</div>
			<ion-button [disabled]="isClosing" color="primary" shape="round" class="no-transform" (click)="close()">
				{{ "CLOSE_LOCATION__CLOSE_RIDE" | transloco }}
			</ion-button>
		</div>
	</div>
</ng-template>
